import { create } from 'zustand'

interface KeyModificationDialogState {
    isOpen: boolean
    isPTKey: boolean
    originalKey: string
    modifiedKey: string
    onProceed: (() => void) | null
    onCancel: (() => void) | null
    showDialog: (params: {
        isPTKey: boolean
        originalKey: string
        modifiedKey: string
        onProceed: () => void
        onCancel: () => void
    }) => void
    closeDialog: () => void
}

/**
 * Zustand store for managing the Key Modification Warning Dialog state
 */
export const useKeyModificationDialogStore = create<KeyModificationDialogState>(
    (set) => ({
        isOpen: false,
        isPTKey: false,
        originalKey: '',
        modifiedKey: '',
        onProceed: null,
        onCancel: null,
        showDialog: ({
            isPTKey,
            originalKey,
            modifiedKey,
            onProceed,
            onCancel,
        }) => {
            set({
                isOpen: true,
                isPTKey,
                originalKey,
                modifiedKey,
                onProceed,
                onCancel,
            })
        },
        closeDialog: () => {
            set({
                isOpen: false,
                isPTKey: false,
                originalKey: '',
                modifiedKey: '',
                onProceed: null,
                onCancel: null,
            })
        },
    })
)
